$(document).ready(function(){
    // UI stuff
    // bind inline label functionality
    UI.toggleInlineLabel();
    UI.renderCustomSelect();
    UI.interfaceReady();

    // bind inline form validation plugin
    $('.js-form-validation').validate();

    // resize the frame for embedding
    setTimeout(function(){ Embed.resize(); }, 10);

    // bind Chosen plugin
    if ( $.fn.chosen ) {
        // TODO : update Chosen selector globally
        $('.chosen-select').chosen({
            width : '100%',
            enable_split_word_search : false
        });
    }

    // init AutoNumeric
    if ( $('.currency-input').length ) {
        $('.currency-input').each(function(){
            AutoNumericNumber('#' + $(this).attr('id'));
        });
    }

    // bind country selector plugin
    if ( $.fn.countrySelector ) {
        $('.has-country-selector').countrySelector();
    }

    // easy way to show/hide content from the select option
    $('.js-show-toggle-select-content').on('change', function(){
        var $selected = $(this).find('option:selected'),
            $container = $($selected.attr('data-content-toggle'));

        // make sure we don't trigger changes on hidden restrictions for mobile
        if ( $(this).is('.select-restriction') && ! $(this).is(':visible') ) return;

        $selected.siblings().each(function(){
            $($(this).attr('data-content-toggle')).addClass('hide-content');
        });

        UI.toggleContent($selected);

        Embed.resize();
    });

    // easy way to show/hide content from another element
    $('.js-toggle-content').on('click', function(e){
        UI.toggleContent(this);

        Embed.resize();

        e.preventDefault();
    });

    // TODO : move this to potentially use UI.setupTabs.hashTabs();
    // bind tabbed content
    // ie: payment methods, login form, etc.
    $('.js-tab').on('click', function(e) {
        // temp fix for active-tab link
        $('.active-tab').removeClass('active-tab');
        UI.toggleTabbedContent($(this));

        Embed.resize();
    });

    $('.js-toggle-item-settings').on('click', function(e){
        var $container = $(this).closest('.ui-management-list'),
            $item = $(this).closest('.ui-management-item');

        e.preventDefault();

        // remove the active class from all other items in the management list
        $container.find('.ui-management-item').not($item).removeClass('active');

        // toggle the active class for item being edited
        $item.toggleClass('active');

        Embed.resize();
    });

    // bind password reset
    $('.js-toggle-password-reset').on('click', function(e){
        // manually hiding the other views
        $('.login-container .toggle-content').addClass('hide-content');

        // showing the password view
        UI.toggleContent(this);

        Embed.resize();
    });

    if ( $('.js-recurring-history').length ) {
        $('.js-recurring-history').paginate();
    }

    if ($('.js-linkable-recurring-container').length) {
        const recurringSupportedPaymentTypes = [];
        const $recurringTableContainer = $('.js-linkable-recurring-container');
        const recurringTableRows = $recurringTableContainer.find('.data-row');

        // build list of unique supported payment methods from available recurring payments
        for (let i=0; i<recurringTableRows.length; i++) {
            if ($(recurringTableRows[i]).attr('data-recurring-allowed').length) {
                const allowed = $(recurringTableRows[i]).attr('data-recurring-allowed').split(', ');
                for (let j=0; j<allowed.length; j++) {
                    if (!recurringSupportedPaymentTypes.includes(allowed[j])) {
                        recurringSupportedPaymentTypes.push(allowed[j]);
                    }
                }
            }
        }

        // on pageload, if the form supports the method type of the recurring,
        // show the recurring table
        const supportedMethods = {
            visa: $recurringTableContainer.attr('data-support-visa') === '1' ? true : false,
            amex: $recurringTableContainer.attr('data-support-amex') === '1' ? true : false,
            discover: $recurringTableContainer.attr('data-support-discover') === '1' ? true : false,
            mastercard: $recurringTableContainer.attr('data-support-mastercard') === '1' ? true : false,
            echeck: $recurringTableContainer.attr('data-support-echeck') === '1' ? true : false,
        };

        // see which methods are supported by the
        const allowedVisa = supportedMethods.visa && recurringSupportedPaymentTypes.includes('VS');
        const allowedAmex = supportedMethods.amex && recurringSupportedPaymentTypes.includes('AM');
        const allowedDiscover = supportedMethods.discover && recurringSupportedPaymentTypes.includes('DC');
        const allowedMastercard = supportedMethods.mastercard && recurringSupportedPaymentTypes.includes('MC');
        const allowedCheck = supportedMethods.echeck && recurringSupportedPaymentTypes.includes('ck');

        if (allowedVisa || allowedAmex || allowedDiscover || allowedMastercard || allowedCheck) {
            $recurringTableContainer.removeClass('hide-content');
        }

        // listen for changes to Payment Type to toggle the recurring table
        $('.js-payment-type-option').on('change', function(){
            const _val = $(this).val();
            if (_val === 'check' && allowedCheck) {
                $recurringTableContainer.removeClass('hide-content');
            } else if (_val === 'card' && (allowedVisa || allowedAmex || allowedDiscover || allowedMastercard)) {
                $recurringTableContainer.removeClass('hide-content');
            } else {
                $recurringTableContainer.addClass('hide-content');
            }
            Embed.resize();
        });

        // bind the Select All checkbox if the 'Link an Existing
        // Recurring Payment' section is available in Add Payment Method
        $('.select-deselect-all').on('change', function() {
            const target = $(this).attr('data-target');

            if ( $(this).hasClass('is-selected') ) {
                $('[name="' + target + '"]').prop('checked', false).removeClass('auto-selected');
            } else {
                $('[name="' + target + '"]').prop('checked', true).addClass('auto-selected');
            }
            $(this).toggleClass('is-selected');
        });
        $(document).on('click', '.auto-selected', function() {
            $(this).closest('.data-table')
                .find('.select-deselect-all')
                .prop('checked', false)
                .removeClass('is-selected');
        });

        // bind the Card Number input to track which CC type is in use
        $('#payment-card-number').on('keyup blur', function(){
            var cardType = QGIV.Payment.getCardType($(this).val(), false);

            if (cardType && recurringSupportedPaymentTypes.includes(cardType)) {
                $recurringTableContainer.removeClass('hide-content');
            } else {
                $recurringTableContainer.addClass('hide-content');
            }
            QGIV.Utilities.debounce(function () {
                Embed.resize();
            }, 500)
        });
    }

    // on page load, see if there are any tabs that should be preloaded based on hash in the URL
    if ( window.location.hash ) {
        var hashValue = window.location.hash,
            $element = $('a[href="' + hashValue + '"]');

        if ( $element.length ) {
            $element.trigger('click');
        }
    }

    var is_mobile = (/iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
    if (is_mobile && $('.back-to-givi').length > 0) {
        $('.back-to-givi').removeClass('hide-content');
    }

    // bidder paymet notif
    var $bidderModal = $('.js-bidder-payment-modal');

    $bidderModal.modal({
        disableTrigger : true,
        width : 'width-550-hard',
        onClose : function(){
            // making sure to reset the payment ID to delete, just in case
            this.$modal.attr('data-id', '');
        },
        accept : function(){
            // remove any messages
            $('.ui-message').remove();
        }
    });

    // delete payment functionality
    var $paymentModal = $('.js-delete-payment-modal');

    $paymentModal.modal({
        disableTrigger : true,
        width : 'width-550-hard',
        onClose : function(){
            // making sure to reset the payment ID to delete, just in case
            this.$modal.attr('data-id', '');
        },
        accept : function(){
            // remove any messages
            $('.ui-message').remove();

            var recurring = [],
                post = [];

            // we have recurring methods tied. gather new payment inputs
            if ( $paymentModal.find('.js-associated-recurring table').is(':visible') && $paymentModal.find('.js-recurring-payment-methods').length ) {
                $paymentModal.find('.js-associated-recurring table tr').each(function() {
                    var recurId = $(this).attr('data-id'),
                        newPayment = $(this).find('.js-recurring-payment-methods').val();

                    post.push('recurring[' + recurId + ']=' + newPayment);

                });

                post = post.join('&');

                $.fn.qpost({
                    csrf: true,
                    method : 'post',
                    data : post,
                    success : function(response){
                        if ( response && response.success ) {
                            // after we've updated the recurring payments,
                            // AJAX call to delete payment method
                            QGIV.Account.deleteObject($paymentModal.attr('data-id'), $('.content-container'), function(response){
                                if ( response.success ) {
                                    location.reload();
                                }
                            });
                        } else {
                            Message.target = $('.content-container');

                            $paymentModal.data('qg_modal').closeModal();

                            if ( response.errors && response.errors.length ) {
                                Message.post(response.errors, 'error');
                            } else {
                                Message.post('An error has occurred. Please try again.');
                            }

                            Embed.top();
                        }
                    }
                });
            } else {
                // no recurrings to update, continue to deletion
                QGIV.Account.deleteObject($paymentModal.attr('data-id'), $('.content-container'), function(response){
                    if (response.success) {
                        location.reload();
                    }
                });
            }
        }
    });

    $('.js-bidder-payment').on('click', function(e){
        var id = $(this).closest('.js-payment-item').attr('data-id');

        // render table of payment recurring methods
        var eventsHTML = '',
            events = PaymentEvents[id].events;

        for (i = 0; i < events.length; ++ i) {
            eventsHTML += events[i] + "<br/>";
        }

        // add the new markup to the table
        $bidderModal.find('.js-event-names').empty().html(eventsHTML);

        // show the modal
        $bidderModal
            .attr('data-id', id)
            .data('qg_modal').showModal();

        Embed.resize();

        e.preventDefault();
    });

    $('.js-delete-payment').on('click', function(e){
        var id = $(this).closest('.js-payment-item').attr('data-id');

        // or with type converion
        var noAlternateMethods = $("#no-alts").val() == true;

        // render table of payment recurring methods
        var recurringHTML = '',
            recurring = PaymentRecurring[id].recurring,
            alternatePayments = PaymentRecurring[id].alternatePayments;

        // if there are other payment methods available, build out the table
        if ( ! noAlternateMethods ) {
            for ( var key in recurring ) {
                recurringHTML += '<tr class="data-row" data-id="' + key + '">';
                recurringHTML +=    '<td>' + recurring[key].title + '</td>';
                recurringHTML +=    '<td class="width-100-hard">$' + recurring[key].amount + '</td>';
                recurringHTML +=    '<td class="text-right">';
                recurringHTML +=        '<select class="ui-select js-recurring-payment-methods width-125-hard">';

                for ( var paymentKey in alternatePayments[key] ) {
                    recurringHTML +=        '<option value="' + paymentKey + '">' + alternatePayments[key][paymentKey].title + '</option>';
                }

                recurringHTML +=        '</select>';
                recurringHTML +=    '</td>';
                recurringHTML += '</tr>';
            }

            // show the proper label
            $('.js-recurring-to-update-text').removeClass('hide-content');
            $('.js-recurring-to-delete-text').addClass('hide-content');
            $('.js-has-alternate-payments').removeClass('hide-content');
            $('.js-no-alternate-payments').addClass('hide-content');
            $('.js-delete-payment').removeClass('hide-content');
            $('.js-delete-payment-header').removeClass('hide-content');
            $paymentModal.find('.js-associated-recurring table').removeClass('no-highlight');
        } else if ( ! $.isEmptyObject(recurring) ) {
            for ( var key in recurring ) {
                recurringHTML += '<tr class="data-row" data-id="' + key + '">';
                recurringHTML +=    '<td>' + recurring[key].title + '</td>';
                recurringHTML +=    '<td class="width-100-hard">$' + recurring[key].amount + '</td>';
                recurringHTML += '</tr>';
            }

            // show the proper label
            $('.js-recurring-to-delete-text').removeClass('hide-content');
            $('.js-recurring-to-update-text').addClass('hide-content');
            $('.js-has-alternate-payments').addClass('hide-content');
            $('.js-no-alternate-payments').removeClass('hide-content');
            $('.js-delete-payment').addClass('hide-content');
            $('.js-delete-payment-header').addClass('hide-content');

            $paymentModal.find('.js-associated-recurring table').addClass('no-highlight');
        }

        // add the new markup to the table
        $paymentModal.find('.js-associated-recurring table').empty().html(recurringHTML);

        // no recurring methods tied to payment. hide the text and table
        if ( recurringHTML == '' ) {
            $('.js-associated-recurring').addClass('hide-content');
        } else {
            $('.js-associated-recurring').removeClass('hide-content');
        }

        // show the modal
        $paymentModal
            .attr('data-id', id)
            .data('qg_modal').showModal();

        Embed.resize();

        e.preventDefault();
    });


    // delete recurring functionality
    var $recurringModal = $('.js-delete-recurring-modal');

    $recurringModal.modal({
        disableTrigger : true,
        width : 'width-450-hard',
        onClose : function(){
            // making sure to reset the recurring ID to delete, just in case
            this.$modal.attr('data-id', '');
        },
        accept : function(){
            // AJAX call to delete payment
            QGIV.Account.deleteObject($recurringModal.attr('data-id'), $('.content-container'), function(){
                $recurringModal.data('qg_modal').closeModal();

                // if there are no more recurring payments, show the empty data message
                if ( ! $('.js-recurring-item').length ) {
                    $('.js-empty-recurring').removeClass('hide-content');
                }
            });
        }
    });

    $('.js-delete-recurring').on('click', function(e){
        $recurringModal
            .attr('data-id', $(this).closest('.js-recurring-item').attr('data-id'))
            .data('qg_modal').showModal();

        $('.js-recurring-exp-date', $recurringModal).text($(this).closest('.js-recurring-item').attr('data-exp'));

        e.preventDefault();
    });

    $('.js-cancel-recurring').on('click', function(e){
        $recurringUnsubscriptionModal = $('#cancel-recurring-modal').modal({
            bgClose : false,
            disableTrigger : true,
            width : 'auto-width',
            accept : function() {
                var postString = 'confirm=yes';

                $.fn.qpost({
                    url : url('account/recurring_donation_unsubscribe'),
                    data : postString,
                    success : function(data) {
                        if ( data && data.success ) {
                            window.location.reload('true');
                        } else if ( data && data.errors ) {
                            Message.target = '#cancel-recurring-modal';
                            Message.post(data.errors, 'error');
                        }
                    }
                });
            },
            decline : function() {
                $recurringUnsubscriptionModal.data('qg_modal').closeModal();
            }
        });

        $recurringUnsubscriptionModal.data('qg_modal').showModal();

        e.preventDefault();
    });

    // bind recurring pause and run toggle
    $('.js-update-recurring-status').on('change', function(){
        $('.ui-message').remove();

        var $toggle = $(this),
            $recurring = $toggle.closest('.js-recurring-item'),
            id = $recurring.attr('data-id'),
            status = $toggle.is(':checked') ? '1' : '0';

        var postString = 'recurring_status=' + status + '&update_state=1&recurring=' + encodeURIComponent(id);

        var onError = function(error) {
            var error = error || 'An error has occurred. Please try again.';

            // un-check the boxes on error
            if ( ! $toggle.is(':checked') ) {
                $toggle.prop('checked', true);
                $recurring.removeClass('is-disabled');
            } else {
                $toggle.prop('checked', false);
                $recurring.addClass('is-disabled');
            }

            // trigger an error message to select an amount
            Message.target = $recurring.closest('.ui-management-list');
            Message.post(error, 'error');

            Embed.resize();
            Embed.top();
        }

        // AJAX call to recurring
        $.fn.qpost({
            url : url('account_recurring', [QGIV.Account.id]),
            csrf: true,
            method : 'post',
            data : postString,
            success : function(result){
                if ( ! result || ! result.success ) {
                   onError(result.errors);
                } else {
                    // the toggle isn't checked which means it's disabled
                    if ( ! $toggle.is(':checked') ) {
                        $recurring.addClass('is-disabled');
                        $recurring.removeClass('is-active');
                    } else {
                        $recurring.addClass('is-active');
                        $recurring.removeClass('is-disabled');
                    }
                }
            },
            failure : function() {
                onError(false);
            }
        });
    });

    // radio buttons toggling content
    var currentFrequency = $('.js-recurring-frequency-option:checked').val();

    $('.js-recurring-frequency-option').on('click', function (e) {
        // show the active selection
        $(this).closest('.ui-option')
            .addClass('is-active')
            .siblings()
            .removeClass('is-active');

        // if the frequency is changed, we need to prompt for next bill date
        if ( $(this).val() !== currentFrequency ) {
            $('.js-next-bill-section').removeClass('hide-content');
        } else {
            $('.js-next-bill-section').addClass('hide-content');
        }

        // we need to re-authenticate with PayPal since the billing type is changing
        if ( typeof QGIV.PayPal !== 'undefined' ) {
            QGIV.PayPal.resetAuthentication();
        }

        Embed.resize();
    });

    // trigger click on page load if selected
    $('.js-recurring-frequency-option:checked').trigger('click');


    // trigger donation amount UI
    // check for required custom fields when donation amount changes
    $('.js-donation-amount-option').on('change', function(){
        var amount = '0.00';
        var $item = $(this).closest('.js-donation-amount-item'),
            $customAmount = $item.find('.donation-amount-other-input'),
            $parent = $(this).closest('.js-custom-amounts'),
            activeClass = 'is-active';

        // add selection class to this item
        // check if we're using the amount with description interface
        if ( $parent.length && $parent.hasClass('has-description') ){
            activeClass += ' ui-border-primary-color';
        } else {
            activeClass += ' ui-text-primary-color';
        }

        // check if it's a custom amount
        if ( $(this).val() == 'other' ){
            // focus on the input field
            $customAmount.focus();

            // add border if the amounts have name/description
            if ( $item.is('.donation-amount-description-item') ){
                $item.addClass('ui-border-primary-color');
            }

            // if the value is greater than 0, make sure we update the total
            if ( $customAmount.val() > 0 ){
                amount = $customAmount.val();
            }
        } else {
            // store the donation amount for calculations
            amount = $(this).attr('data-value');
        }

        // remove the existing active classes from donation items and add the active class to this one
        $parent.find('.js-donation-amount-item').removeClass(activeClass);
        $item.addClass(activeClass);

        // only change the text color if it's not the "other" amount
        if ( $item.is('.js-other-donation-amount-item') ){
            $item.removeClass('ui-text-primary-color');
        }

        // update our overall transaction total
        QGIV.Form.updateTransactionTotal($(this).closest('form'), amount);
    });

    // when selecting a pledge, see if we should add a tip
    $('.js-select-pledge').on('change', function(){
        var amount = ( $(this).is(':radio') ? $(this).attr('data-value') : $(this).val() );

        QGIV.Form.updateTransactionTotal($(this).closest('form'), amount);
    });

    // trigger change for pre-selected option on page load
    $('.js-donation-amount-option:checked, .js-select-pledge:checked').trigger('change');

    // add selection classes for custom other amount
    $('.donation-amount-other-input').on('focus', function(){
        var $item = $(this).closest('.js-donation-amount-item'),
            $parent = $(this).closest('.js-custom-amounts'),
            activeClass = 'is-active';

        // add selection class to this item
        if ( $parent.length && $parent.hasClass('has-description') ){
            activeClass += ' ui-border-primary-color';
        } else {
            activeClass += ' ui-text-primary-color';
        }

        // clear any selected donation amounts
        $('.js-select-donation-amount').removeClass(activeClass);

        // add focus class
        $(this).addClass('is-active');

        // making sure the input indicating that the other amount option is checked
        if ( ! $item.find('.js-donation-amount-option').prop('checked') ){
            $item.trigger('click');
        }
    }).on('change', function(){
        var value = $(this).val();

        value = QGIV.Utilities.toFloat(value);

        if ( value > 0 ){
            // if the amount is greater than 0, see if we should add a fee
            QGIV.Form.updateTransactionTotal($(this).closest('form'), value);
        }
    });

    // update cost on option selection
    $('.js-multi-restriction-amount').on('change', function(){
        QGIV.Form.getGroupTotal(this);
    });

    $('.js-multi-restriction-amount:first').trigger('change');

    // restriction selection
    $('.js-select-restriction').on('change', function(){
        var $selected = $(this).find('option:selected'),
            $container = $($selected.attr('data-content-toggle'));

        // make sure we don't trigger changes on hidden restrictions for mobile
        if ( $(this).is('.select-restriction') && ! $(this).is(':visible') ) return;

        $selected.siblings().each(function(){
            $($(this).attr('data-content-toggle')).addClass('hide-content');
        });

        UI.toggleContent($selected);

        // check if there is something to update, and if so, trigger it
        if ( $container.find('.js-select-sub-restriction') ){
            $container.find('.js-select-sub-restriction').trigger('change');
        }

        // check if the item has a description to show
        var description = $selected.attr('data-description'),
            target = $(this).attr('data-content-update');

        $(target).empty();
        $(target).html(description).removeClass('hide-content');

        Embed.resize();
    });

    // trigger change on restriction on page load
    $('.js-select-restriction:visible').trigger('change');


    // toggling company donation
    $('.js-toggle-company-donation').on('change', function() {
        // we have a company donation, show the company fields
        if ( $(this).is(':checked') ) {
            $('.donation-type-company')
                .removeClass('hide-content')
                .find('.bypassPostBuild')
                .addClass('validateEmpty');
            $("#first-name").removeClass("validateEmpty").closest('.field-container').find("span.field-required-label").addClass("hide-content");
            $("#last-name").removeClass("validateEmpty").closest('.field-container').find("span.field-required-label").addClass("hide-content");
            $("#employer-information").addClass("hide-content");
        }
        // standard donation
        else {
            $('.donation-type-company').addClass('hide-content');
            $("#employer-information").removeClass('hide-content');
            $("#first-name").addClass("validateEmpty").closest('.field-container').find("span.field-required-label").removeClass("hide-content");
            $("#last-name").addClass("validateEmpty").closest('.field-container').find("span.field-required-label").removeClass("hide-content");
        }

        Embed.resize();
    });

    // on page load, trigger change on company donation toggle if it's checked
    $('.js-toggle-company-donation:checked').trigger('change');


    // TODO : bind sorting plugin


    // bind general datepicker
    if ( $.fn.Zebra_DatePicker ) {
        $('.js-datepicker').Zebra_DatePicker({
            direction: 1,
            format: 'm/d/Y',
            show_icon : false,
            show_clear_date : false,
            readonly_element : false
        });

        // bind trasaction filtering datepicker
        $('.js-filter-start-date').Zebra_DatePicker({
            direction: 0,
            format: 'm/d/Y',
            show_icon : false,
            show_clear_date : false,
            readonly_element : false,
            pair : $('.js-filter-end-date')
        });

        $('.js-filter-end-date').Zebra_DatePicker({
            direction: true,
            format: 'm/d/Y',
            show_icon : false,
            show_clear_date : false,
            readonly_element : false
        });

        // recurring frequency end date
        $('.js-recurring-end-date').Zebra_DatePicker({
            direction: [$('.js-recurring-end-date').attr('data-start-date'), false],
            format: 'm/d/Y',
            show_icon : false,
            show_clear_date : false,
            readonly_element : false
        });
    }

    // update transaction table when changing per page dropdown
    $('.js-transaction-results').on('change', '.js-filter-per-page', function(e) {
        // since we're changing the amount displayed per page, reset to page one
        $('.js-pagination-item.active').removeClass('active');
        $('.js-pagination-page:first').addClass('active');

        // update transaction table
        QGIV.Account.getTransactions();
        e.preventDefault();
    });

    // update transaction table when clicking pagination item
    $('.js-transaction-results').on('click', '.js-pagination-item', function(e) {
        var $pagination = $(this).closest('.js-pagination'),
            $activePage = $pagination.find('.js-pagination-page.active');

        // cancel everything if the link is inactive
        if ( $(this).is('.inactive') ) return false;

        // if we click the next page button
        if ( $(this).is('.js-pagination-next') ) {
            // if the current page is not the last page
            if ( ! $activePage.is($pagination.find('.js-pagination-page:last')) ) {
                var newPage = parseInt($activePage.attr('data-page')) + 1;

                $activePage.removeClass('active');

                // set the next page as the active one
                $pagination.find('.js-pagination-page[data-page="' + newPage + '"]').addClass('active');
            }
        }
        // if we click the previous page
        else if ( $(this).is('.js-pagination-previous') ) {
            // if the current page is not the first one
            if ( ! $activePage.is($pagination.find('.js-pagination-page:first')) ) {
                var newPage = parseInt($activePage.attr('data-page')) - 1;

                $activePage.removeClass('active');

                $pagination.find('.js-pagination-page[data-page="' + newPage + '"]').addClass('active');
            }
        }
        // if we just click on a specific page
        else {
            // if the current page is not the one we clicked
            if ( ! $activePage.is($(this)) ) {
                $activePage.removeClass('active');
                $(this).addClass('active');
            }
        }

        // update transactions
        QGIV.Account.getTransactions();

        e.preventDefault();
    });

    // update transaction table when applying filters
    $('.js-update-transactions').on('click', function(e){
        QGIV.Account.getTransactions();
        Embed.resize();
    });

    // update transaction table on page load
    if ( $('.js-update-transactions').length ) {
        QGIV.Account.getTransactions();
        Embed.resize();
    }

    // PayPal authentication
    if ( typeof QGIV.PayPal !== 'undefined' ) {
        QGIV.PayPal.onBeforeOpen = function($button){
            var $container = $button.closest('.recurring-form'),
                $frequency = $container.find('.js-recurring-frequency'),
                frequency = $frequency.val();

            // make sure the total is a number
            total = QGIV.Account.calculateItemTotal($container);

            // make sure we have a valid amount
            if ( ! isNaN(total) && total > 0 ){
                // grab transaction amount
                this.path += '&amount=' + total;
                this.authorizedAmount = total;

                // set the amount to the paypal recurring input
                $container.find('.js-paypal-total').val(total);

                // check if donation tab is selected and we have a recurring transaction
                if ( $frequency.length && frequency !== 'n' ){
                    this.path += '&recurring=' + frequency;

                    // check if we should add start date
                    this.path += '&begin_date=' + $container.find('.js-recurring-start-date').val();

                    if ( $container.find('.js-recurring-end-date').length && $('.js-recurring-end-date').val() !== '' ){
                        this.path += '&end_date=' + $container.find('.js-recurring-end-date').val();
                    }
                }

                // we've got what we need, make sure the session is validated
                this.validated = true;
            } else {
                // un-validate the PayPal session since there are errors
                this.validated = false;

                // trigger an error message to select an amount
                Message.target = $container;
                Message.post('Please select an amount.', 'error');
            }
        };

        QGIV.PayPal.init();
    }

    // create account form
    $('.js-create-account-form').on('submit', function(e){
        e.preventDefault();

        // prevent double processing
        if ( QGIV.Account.processing ) return false;
        QGIV.Account.processing = true;

        // remove any messages
        $('.ui-message').remove();

        var $form = $(this),
            errors = $form.data('qg_validation').validateForm();

        if ( errors.length ) {
            // display errors
            Message.target = $form;
            Message.post(errors, 'error');

            QGIV.Account.processing = false;
        } else {
            var exclude = $("#is-company-donation").is(":checked") ? ["Personal[firstName]", "Personal[lastName]", "Personal[employer]"] : ["Personal[organization]"];
            var data = buildPostString($form, exclude);

            if ($('#transaction-id').length && $('#transaction-id').val().length) {
                data += '&transaction=' + $('#transaction-id').val();
            }

            if ( $('#form-id').length && $('#form-id').val().length ) {
                data += '&form=' + $('#form-id').val();
            }

            if ( $('#form-key').length && $('#form-key').val().length ) {
                data += '&formKey=' + $('#form-key').val();
            }
            // form template check to send embed value in post data, FormTemplate::NEW_STANDARD_FORM
            if ( $('#form-template').length && $('#form-template').val().length && $('#form-template').val() === "8") {
                data += '&embed=1';
            }

            // AJAX call to create account
            $.fn.qpost({
                url : '/account/create?formId=' + $('#form-id').val(),
                csrf: false,
                method : 'post',
                data : data,
                success : function(result){
                    if ( result && result.success ) {
                        if ( result.accountId ) {
                            // if we're embedding we need to send PostMessage back to parent with the account ID and close the frame
                            if ( QGIV.Embed ) {
                                QGIV.Embed.send({
                                    event : "login",
                                    data : {
                                        account : result.accountId,
                                        donorAccount : result.donorAccount
                                    }
                                });
                                QGIV.Account.processing = false;
                            } else {
                                // perform redirect
                                window.location = QGIV.Account.formatURL('/account/' + result.accountId + '/');
                            }
                        } else if ( result.previousAccount ) {
                            var $msg = '<div class="ui-message error">An account with this email address was previously deleted. <a href="#" class="js-reactivate-account">Reactivate Your Account<a/></div>';

                            $form.prepend($msg);
                            QGIV.Account.processing = false;
                        }
                    } else if ( result.errors ) {
                        // report errors
                        Message.target = $form;
                        Message.post(result.errors, 'error');
                        QGIV.Account.processing = false;
                    } else {
                        // report generic error
                        Message.target = $form;
                        Message.post('An error has occurred. Please try again later.', 'error');
                        QGIV.Account.processing = false;
                    }
                },
                failure : function(){
                    // report generic error
                    Message.target = $form;
                    Message.post('An error has occurred. Please try again later.', 'error');
                    QGIV.Account.processing = false;
                }
            });
        }
    });


    // login form
    $('.js-login-form').on('submit', function(e){
        e.preventDefault();

        // prevent double processing
        if ( QGIV.Account.processing ) return false;
        QGIV.Account.processing = true;

        var $form = $(this),
            $submit = $form.find('.js-form-submit-button'),
            submitText = $submit.val(),
            errors = $form.data('qg_validation').validateForm();

        const isStandardDonationForm = $('#donation-form-type').length && $('#donation-form-type').val().length && $('#donation-form-type').val() === "1";
        const isStandardP2P = $('#form-template').length && $('#form-template').val().length && $('#form-template').val() === "10";
        const loginUrl = isStandardP2P && isStandardDonationForm ? "/api/v1/donor/login/" : "/account/login/";

        $submit.val($submit.attr('data-submit-text')).prop('disabled', true);

        if ( errors.length ) {
            // display errors
            Message.target = $form;
            Message.post(errors, 'error');

            QGIV.Account.processing = false;
            $submit.val(submitText).prop('disabled', false);
        } else {
            var data = buildPostString($form);

            if ( $('#transaction-id').length && $('#transaction-id').val().length ) {
                data += '&transaction=' + $('#transaction-id').val();
            }

            if ( $('#form-id').length && $('#form-id').val().length ) {
                data += '&form=' + $('#form-id').val();
            }

            if ( isStandardP2P && isStandardDonationForm ) {
                data += '&productType=3';
            }


            // AJAX call to login
            $.fn.qpost({
                url : loginUrl,
                csrf: false,
                method : 'post',
                data : data,
                success : function(result){
                    if ( result && result.success && result.accountId ) {
                        // if we're embedding we need to send PostMessage back to parent with the account ID and close the frame
                        if ( QGIV.Embed ) {
                            QGIV.Embed.send({
                                event : "login",
                                data : {
                                    account : result.accountId,
                                    donorAccount : result.donorAccount
                                }
                            });
                            QGIV.Account.processing = false;
                        } else {
                            // perform redirect
                            if ($('#redirect_url').length && $('#redirect_url').val()) {
                                window.location = $('#redirect_url').val();
                            } else {
                                window.location = QGIV.Account.formatURL('/account/' + result.accountId + '/');
                            }
                        }
                    } else if ( result.errors ) {
                        // report errors
                        Message.target = $form;
                        Message.post(result.errors, 'error');

                        QGIV.Account.processing = false;
                        $submit.val(submitText).prop('disabled', false);
                    } else {
                        // report generic error
                        Message.target = $form;
                        Message.post('An error has occurred. Please try again later.', 'error');

                        QGIV.Account.processing = false;
                        $submit.val(submitText).prop('disabled', false);
                    }
                },
                failure : function(){
                    // report generic error
                    Message.target = $form;
                    Message.post('An error has occurred. Please try again later.', 'error');

                    QGIV.Account.processing = false;
                    $submit.val(submitText).prop('disabled', false);
                }
            });
        }
    });


    // submit password reset form
    $('.js-reset-password-form').on('submit', function(e){
        e.preventDefault();

        // prevent double processing
        if ( QGIV.Account.processing ) return false;
        QGIV.Account.processing = true;

        var $form = $(this),
            $submit = $form.find('.js-form-submit-button'),
            submitText = $submit.val(),
            resetKey = $('input[name="resetKey"]').val(),
            errors = $form.data('qg_validation').validateForm();

        $submit.val($submit.attr('data-submit-text')).prop('disabled', true);

        if ( errors.length ) {
            // display errors
            Message.target = $form;
            Message.post(errors, 'error');

            QGIV.Account.processing = false;
            $submit.val(submitText).prop('disabled', false);
        } else {
            // build the post string for recurring
            var data = buildPostString($form);

            if ($('#reset_redirect').length > 0) {
                data += '&redirect=' + $('#reset_redirect').val();
            }

             if ($('#reset_redirect_form').length > 0) {
                data += '&redirectForm=' + $('#reset_redirect_form').val();
            }

            // call to reset password
            $.fn.qpost({
                url : url('account_reset', [QGIV.Account.id, resetKey]),
                csrf: false,
                method : 'post',
                data : data,
                success : function(result){
                    if ( result && result.success ) {
                        var redirectUrl = '';

                        // perform redirect
                        if (result.redirect) {
                            redirectUrl = result.redirect;
                        } else {
                            redirectUrl = url('account_login', [QGIV.Account.id]);
                            redirectUrl = QGIV.Account.formatURL(redirectUrl);
                        }

                        // if we're embedding we need to send PostMessage back to parent with the account
                        if ( QGIV.Embed ) {
                            QGIV.Embed.send({
                                event : "reset",
                                data : {
                                    account : QGIV.Account.id
                                }
                            });
                        }
                        window.location.href = redirectUrl;
                    } else if ( result.errors.length > 0 ) {
                        // report errors
                        Message.target = $form;
                        Message.post(result.errors, 'error');

                        QGIV.Account.processing = false;
                        $submit.val(submitText).prop('disabled', false);
                    } else {
                        //generic error
                        Message.target = $form;
                        Message.post('We were unable to reset the password. Please try again later', 'error');

                        QGIV.Account.processing = false;
                        $submit.val(submitText).prop('disabled', false);
                    }
                },
                failure : function(){
                    Message.target = $form;
                    Message.post('We were unable to reset the password. Please try again later', 'error');

                    QGIV.Account.processing = false;
                    $submit.val(submitText).prop('disabled', false);
                }
            });
        }
    });

    // submit password reset form
    $('.js-reset-password-form-login').on('submit', function(e){
        e.preventDefault();

        // prevent double processing
        if ( QGIV.Account.processing ) return false;
        QGIV.Account.processing = true;

        const isStandardDonationForm = $('#donation-form-type').length && $('#donation-form-type').val().length && $('#donation-form-type').val() === "1";

        var $form = $(this),
            $submit = $form.find('.js-form-submit-button'),
            submitText = $submit.val(),
            errors = $form.data('qg_validation').validateForm();

        $submit.val($submit.attr('data-submit-text')).prop('disabled', true);

        if ( errors.length ) {
            // display errors
            Message.target = $form;
            Message.post(errors, 'error');

            QGIV.Account.processing = false;
            $submit.val(submitText).prop('disabled', false);
        } else {
            // build the post string for recurring
            var data = buildPostString($form);

            const _url = isStandardDonationForm ? url('resend_password', [$('#form-id').val()]) : url('account_login', []);

            // call to reset password
            $.fn.qpost({
                url : _url,
                csrf: false,
                method : 'post',
                data : data,
                success : function(result){
                    if (result && result.success) {
                        // perform redirect
                        Message.target = $form;
                        Message.post('If an account with your email address was found in our system, a password reset email will be sent to ' + $('#password-email').val(), 'success');

                        QGIV.Account.processing = false;
                        $submit.val(submitText).prop('disabled', false);
                    } else {
                        //generic error
                        Message.target = $form;
                        Message.post('We were unable to send the reset password email. Please try again later', 'error');

                        QGIV.Account.processing = false;
                        $submit.val(submitText).prop('disabled', false);
                    }
                },
                failure : function(){
                    Message.target = $form;
                    Message.post('We were unable to send the reset password email. Please try again later', 'error');

                    QGIV.Account.processing = false;
                    $submit.val(submitText).prop('disabled', false);
                }
            });
        }
    });


    // account profile updates
    $('.js-profile-form').on('submit', function(e){
        e.preventDefault();

        // prevent double processing
        if ( QGIV.Account.processing ) return false;
        QGIV.Account.processing = true;

        var $form = $(this),
            errors = $form.data('qg_validation').validateForm();

        // clear out UI messages
        $('.ui-message').remove();

        if ( errors.length ) {
            // display errors
            Message.target = $form;
            Message.post(errors, 'error');
            Embed.resize();
            Embed.top();

            QGIV.Account.processing = false;
        } else {
            var data = buildPostString($form),
                accountId = $('#account-id').val();

            // AJAX call to profile page
            $.fn.qpost({
                url : '/account/' + accountId + '/me/',
                csrf: true,
                method : 'post',
                data : data,
                success : function(result){
                    if ( result && result.success ) {
                        // notify success
                        Message.target = $form;
                        Message.post('Your information has been successfully updated.', 'success');
                    } else if ( result.errors ) {
                        // report errors
                        Message.target = $form;
                        Message.post(result.errors, 'error');
                    } else {
                        // report generic error
                        Message.target = $form;
                        Message.post('An error has occurred. Please try again later.', 'error');
                    }

                    Embed.resize();
                    Embed.top();

                    QGIV.Account.processing = false;
                },
                failure : function(){
                    // report generic error
                    Message.target = $form;
                    Message.post('An error has occurred. Please try again later.', 'error');
                    Embed.resize();
                    Embed.top();

                    QGIV.Account.processing = false;
                }
            });
        }
    });

    // account password updates
    $('.js-password-form').on('submit', function(e){
        e.preventDefault();

        // prevent double processing
        if ( QGIV.Account.processing ) return false;
        QGIV.Account.processing = true;

        var $form = $(this),
            errors = $form.data('qg_validation').validateForm();

        // clear out UI messages
        $('.ui-message').remove();

        if ( errors.length ) {
            // display errors
            Message.target = $form;
            Message.post(errors, 'error');
            Embed.resize();
            Embed.top();

            QGIV.Account.processing = false;
        } else {
            var data = buildPostString($form),
                accountId = $('#account-id').val();

            // AJAX call to login
            $.fn.qpost({
                url : '/account/' + accountId + '/me/',
                csrf: true,
                method : 'post',
                data : data,
                success : function(result){
                    if ( result && result.success ) {
                        // notify success
                        Message.target = $form;
                        Message.post('Your information has been successfully updated.', 'success');
                    } else if ( result.errors ) {
                        console.log($form);
                        // report errors
                        Message.target = $form;
                        Message.post(result.errors, 'error');
                        QGIV.Account.processing = false;
                    } else {
                        // report generic error
                        Message.target = $form;
                        Message.post('An error has occurred. Please try again later.', 'error');
                        QGIV.Account.processing = false;
                    }

                    Embed.resize();
                    Embed.top();
                },
                failure : function(){
                    // report generic error
                    Message.target = $form;
                    Message.post('An error has occurred. Please try again later.', 'error');
                    Embed.resize();
                    Embed.top();

                    QGIV.Account.processing = false;
                }
            });
        }
    });

    // submit recurring updates
    $('.js-recurring-payment-form').on('submit', function(e){
        e.preventDefault();

        // prevent double processing
        if ( QGIV.Account.processing ) return false;
        QGIV.Account.processing = true;

        var $form = $(this),
            errors = $form.data('qg_validation').validateForm(),
            recurringId = $('.js-recurring-id').val();

        if ( errors.length ) {
            // display errors
            Message.target = $form;
            Message.post(errors, 'error');
            Embed.resize();
            Embed.top();

            QGIV.Account.processing = false;
        } else {
            // build the post string for recurring
            var data = buildPostString($form);

            if ( $form.find('.js-select-restriction').length > 0 ) {
                // add the subrestriction since the build post string function will not build it correctly
                // will only get built if we are using amounts system
                var $selected = $('option:selected', '.js-select-restriction');
                var subrestriction = $selected.attr('data-content-toggle');
                var subrestrictionValue = (typeof($('.js-select-sub-restriction', subrestriction).val()) == 'undefined') ? '' : $('.js-select-sub-restriction', subrestriction).val();
                var restrictionId = $selected.attr('data-restriction');

                data += '&Donations[0][subrestriction] ='+encodeURIComponent(subrestrictionValue);

                // add the restriction id since the build post string function won't grab it
                // will only get built if we are using amounts system
                data += '&Donations[0][restrictionId] ='+encodeURIComponent(restrictionId);
            }

            // NOTE: only passing restriction id to the back-end on single-restriction giving (not multi)
            // because multi restriction giving does not support editing restrictions, only amount modifications
            // if this changes in the future, we will have to update the logic to include restriction id too

            // override company post to make sure that the value does not get overwritten by company field
            if ( $form.find('#is-company-donation').is(':checked') ) {
                //set company name
                data += '&Personal[organization] ='+encodeURIComponent($("#company-name").val());
            }

            // AJAX call to recurring edit
            $.fn.qpost({
                url : url('account_recurring_edit', [QGIV.Account.id, recurringId]),
                csrf: false,
                method : 'post',
                data : data,
                success : function(result){
                    if ( result && result.success ) {
                        // perform redirect
                        window.location.reload('true');
                    } else if ( result.errors.length > 0 ) {
                        // report errors
                        Message.target = $form;
                        Message.post(result.errors, 'error');
                        QGIV.Account.processing = false;
                    } else {
                        Message.target = $form;
                        Message.post('We were not able to edit the recurring payment. Please try again later', 'error');
                        QGIV.Account.processing = false;
                    }

                    Embed.resize();
                    Embed.top();
                },
                failure : function(){
                    Message.target = $form;
                    Message.post('We were not able to edit the recurring payment. Please try again later', 'error');
                    Embed.resize();
                    Embed.top();

                    QGIV.Account.processing = false;
                }
            });
        }
    });


    // TODO : update logic to allow for bypassing of credit card validation when editing
    if ( $('.js-payment-information').find('.validateCreditCard').val() ) {
        $('.js-payment-information')
            .find('.validateCreditCard')
            .removeClass('validateCreditCard')
            .on('keypress', function(){
                if ( $(this).val() == '' ) {
                    $(this).addClass('validateCreditCard');
                }
            });
    }

    // payment method additions/editing
    $('.js-payment-method-form').on('submit', function(e) {
        e.preventDefault();

        // prevent double processing
        if ( QGIV.Account.processing ) return;
        QGIV.Account.processing = true;

        var $form = $(this),
            errors = $form.data('qg_validation').validateForm();

        if ( errors.length ) {
            // display errors
            Message.target = $form;
            Message.post(errors, 'error');
            Embed.resize();
            Embed.top();
            QGIV.Account.processing = false;
        } else {
            var data = buildPostString($form),
                paymentId = $('#payment-id').val();

            if ($('.js-linkable-recurring-container').length && !$('.js-linkable-recurring-container').hasClass('hide-content')) {
                data = buildPostString($form, ['linkable-recurring-select']);

                // link any selected linkable recurring gifts
                $form.find('.js-linkable-recurring-table input:checked').each(function() {
                    data += '&payment[recurring][]=' + $(this).closest('tr').attr('data-recurring-id');
                });
            }

            // AJAX call to payment edit
            $.fn.qpost({
                url : '/account/' + QGIV.Account.id + '/payments/' + ((paymentId) ? paymentId : 'add'),
                csrf: true,
                method : 'post',
                data : data,
                success : function(result){
                    if ( result && result.success ) {
                        // notify success
                        window.location.href = QGIV.Account.formatURL('/account/' + QGIV.Account.id + '/payments/');
                    } else if (result.errors && result.errors.length) {
                        // report errors
                        Message.target = $form,
                        Message.post(result.errors, 'error');
                        QGIV.Account.processing = false;
                    } else {
                        // report generic error
                        Message.target = $form,
                        Message.post('There was an error updating your payment method.', 'error');
                        QGIV.Account.processing = false;
                    }

                    Embed.resize();
                    Embed.top();
                },
                failure : function(){
                    // report generic error
                    Message.target = $form,
                    Message.post('There was an error updating your payment method.', 'error');
                    Embed.resize();
                    Embed.top();

                    QGIV.Account.processing = false;
                }
            });
        }
    });

    // for firing off a historical transaction link request
    $('.js-transaction-link-form').on('submit', function(e) {
        e.preventDefault();

        $('.ui-message').remove();

        var $form = $(this)

        // prevent double processing
        if ( QGIV.Account.processing ) return;
        QGIV.Account.processing = true;

        var data = "request=1&source=1";

        // AJAX call to payment edit
        $.fn.qpost({
            url : url('account_activity_link', [QGIV.Account.id]),
            csrf: true,
            method : 'post',
            data : data,
            success : function(result){
                Message.target = $form;
                QGIV.Account.processing = false;

                if ( result && result.success ) {
                    // notify success
                    $form.find('.form-actions').fadeOut(300, function() {
                        $form.find('.form-message').removeClass('hide-content');
                    });
                } else if ( result.errors ) {
                    // report errors
                    Message.post(result.errors, 'error');
                } else {
                    // report generic error
                    Message.post('There was an error while performing your request.', 'error');
                }

                Embed.resize();
                Embed.top();
            },
            failure : function(){
                // report generic error
                Message.target = $form,
                Message.post('There was an error while performing your request.', 'error');
                Embed.resize();
                Embed.top();

                QGIV.Account.processing = false;
            }
        });
    });

    // when our login/create account view is embedded, clicking on the "close" icon will send a PostMessage to the parent frame to destroy the frame
    $('.js-close-embed').on('click', function(){
        if ( typeof QGIV.Embed !== 'undefined' ) {
            QGIV.Embed.send({
                event : 'destroy'
            });
        }
    });

    // if the form is iframed, we need to redirect on logout so we logout via an AJAX call instead
    $('.js-account-logout').on('click', function(e){
        e.preventDefault();

        var redirect = $(this).attr('data-redirect');

        $.fn.qpost({
            url : '/account/login/',
            type : 'post',
            dataType : 'json',
            data : "logout=1",
            success : function(response) {
                window.location.href = redirect;
            }
        });
    });

    // account UI specific login callbacks for social
    QGIV.Account.onLoginSuccess = function(result) {
        var $form = $('.js-login-form');
        if ($('#create-account-form').is(':visible')) {
            $form = $('.js-create-account-form');
        }

        if ( result && result.success && result.accountId ) {
            // if we're embedding we need to send PostMessage back to parent with the account ID and close the frame
            if ( QGIV.Embed ) {
                QGIV.Embed.send({
                    event : "login",
                    data : {
                        account : result.accountId,
                        donorAccount : result.donorAccount
                    }
                });
            } else {
                // perform redirect
                window.location = QGIV.Account.formatURL('/account/' + result.accountId + '/');
            }
        } else {
            // report errors
            Message.target = $form;

            if ( result.errors ) {
                Message.post(result.errors, 'error');
            } else {
                // report generic error
                Message.post('An error has occurred. Please try again later.', 'error');
            }

            Embed.resize();
            Embed.top();

            QGIV.Account.processing = false;
        }
    };

    QGIV.Account.onLoginFail = function(){
        var $form = $('.js-login-form');
        if ($('#create-account-form').is(':visible')) {
            $form = $('.js-create-account-form');
        }

        // report generic error
        Message.target = $form;
        Message.post('There was an error signing you in. Please try again.', 'error');
        Embed.resize();
        Embed.top();
    };

    // the account social messenger handles communication between our social authentication iframe
    // we have to do it like this because the domain comes from "*.qgiv.com" and not necessarily the publicly displayed domain (custom domains)
    QGIV.Account.SocialMessenger = new PostMessage({
        // we use Domain instead of Environment because it guarantees *.qgiv.com
        targetOrigin : QGIV.Domain,
        onReceive : function(event, message){
            var message = QGIV.Utilities.parseJSON(message);

            if ( ! message ) return;

            Message.target = $('.js-login-form, .js-create-account-form');

            // we've received the login event with the FB response
            if ( message.event == 'social-login' ) {
                if ( message.success ) {
                    QGIV.Account.login(message);
                } else if ( message.errors ) {
                    _this.displayMessage(message.errors, 'error');
                } else {
                    _this.displayMessage("An error has occurred. Please try again.", 'error');
                }
            }
        }
    });

    if ( $('#transaction-id').length && $('#transaction-id').val().length ) {
        QGIV.Account.loginParams.push('transaction=' + $('#transaction-id').val());
    }

    if ( $('#form-id').length && $('#form-id').val().length ) {
        QGIV.Account.loginParams.push('form=' + $('#form-id').val());
    }

    // heartbeat
    QGIV.Account.startHeartbeat();

    // gentlemen, start your engines
    QGIV.Account.init();
});

